import { useEffect, useState } from 'react';

import { GraphQLResponse, useGraphQLDebug } from '@/fo/api/magento';
import { Review } from '@/fo/ui/review/catalog/base';
import { UiReviewDetailBase } from '@/fo/ui/review/detail/base';

import { getReview, GetReviewResponse } from '../api/getReview';

export interface FeatureReviewDetailBaseProps {
  reviewId?: string | null;
  onClose?: () => void;
}

export function FeatureReviewDetailBase({
  reviewId,
  onClose
}: FeatureReviewDetailBaseProps) {
  const [review, setReview] = useState<Review | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [debugResponse, setDebugResponse] = useState<
    GraphQLResponse<GetReviewResponse> | undefined
  >();

  useGraphQLDebug(debugResponse, 'getReview');

  useEffect(() => {
    const fetchReview = async () => {
      setIsLoading(true);

      if (!reviewId) {
        return;
      }

      const response = await getReview(reviewId);

      if (response.debugInfo) {
        setDebugResponse({
          data: response,
          statusCode: 200,
          debugInfo: response.debugInfo
        });
      }

      if (!response.review) {
        setIsLoading(false);
        return;
      }

      setReview(response.review);
      setIsLoading(false);
    };

    fetchReview();
  }, [reviewId]);

  return (
    <UiReviewDetailBase
      open={!!reviewId}
      isLoading={isLoading}
      onOpenChange={(open) => {
        if (!open) {
          onClose?.();
        }
      }}
      review={review ?? undefined}
    />
  );
}
